import { render, staticRenderFns } from "./lower.vue?vue&type=template&id=6273b0e2&scoped=true"
import script from "./lower.vue?vue&type=script&lang=js"
export * from "./lower.vue?vue&type=script&lang=js"
import style0 from "./lower.vue?vue&type=style&index=0&id=6273b0e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273b0e2",
  null
  
)

export default component.exports